import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fontFredoka } from "@product/scmp-sdk";

import type { AnswerType } from "scmp-app/components/posties/student-form/types";

import SvgIconCross from "./icon-cross.svg?url";
import SvgIconTick from "./icon-tick.svg?url";

export const Container = styled.div``;

export const StyledInput = styled.input`
  position: absolute;

  cursor: pointer;

  opacity: 0;
`;

type CheckmarkProps = {
  $type: AnswerType;
};
export const Checkmark = styled.span<CheckmarkProps>`
  position: relative;

  display: block;

  inline-size: 24px;
  block-size: 24px;

  border-radius: ${props => (props.$type === "multiple_choice" ? "0px" : "50%")};

  background-color: #ffffff;

  &:after {
    position: absolute;
    content: "";

    display: none;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    inline-size: 24px;
    block-size: 24px;
    margin: 4px;
  }
`;

type LabelProps = {
  $isCorrect: boolean | null;
  $selected: boolean;
  $type: AnswerType;
};
export const Label = styled.label<LabelProps>`
  position: relative;

  display: flex;
  gap: 8px;
  align-items: center;

  padding-block: 16px;
  padding-inline: 12px;

  border-radius: 16px;

  background: ${props => (props.$selected ? "#8AD1EF" : "#dcf1fa")};

  cursor: pointer;

  user-select: none;
  ${props => props.theme.breakpoints.up("desktop")} {
    gap: 24px;

    padding-inline: 24px;
  }

  ${StyledInput}:checked ~ ${Checkmark}:after {
    display: block;
  }

  ${StyledInput} {
    position: absolute;

    inline-size: 0;
    block-size: 0;

    cursor: pointer;

    opacity: 0;
  }

  ${props => {
    switch (props.$type) {
      case "multiple_choice":
        return css`
          ${Checkmark}:after {
            inset-block-start: 50%;
            inset-inline-start: 50%;
            z-index: 1;

            inline-size: 18px;
            block-size: 14px;

            background-image: url(${SvgIconTick});
            background-repeat: no-repeat;
            background-size: contain;

            transform: translate(-50%, -50%);

            ${props.theme.breakpoints.up("desktop")} {
              inline-size: 18px;
              block-size: 13px;
            }
          }

          ${props.$isCorrect &&
          css`
            ${Checkmark} {
              background: #ffffff;
            }
          `}

          ${props.$isCorrect === false &&
          css`
            background-color: #ffdbdb;
            ${StyledInput}[type=checkbox]:checked ~ ${Checkmark} {
              display: block;

              border: 1px solid #ffffff;

              &:after {
                inline-size: 14px;
                block-size: 14px;

                background-image: url(${SvgIconCross});
              }
            }
          `}
        `;
      case "radio_button":
        return css`
          ${Checkmark}:after {
            inset-block-start: 50%;
            inset-inline-start: 50%;

            inline-size: 12px;
            block-size: 12px;

            border-radius: 50%;

            background: #0f75bf;

            transform: translate(-50%, -50%);

            ${props.theme.breakpoints.up("desktop")} {
              inline-size: 16px;
              block-size: 16px;
            }
          }

          ${props.$isCorrect === false &&
          css`
            background-color: #ffdbdb;
            ${Checkmark}:after {
              display: block;

              background-color: #ffdbdb;
            }
          `}
        `;
    }
  }}

  ${props =>
    props.$isCorrect &&
    css`
      color: #ffffff;

      border: 1px solid #000000;

      background-color: #0f75bf;

      ${Checkmark}:after {
        display: block;
      }
    `}
`;

export const LabelText = styled.span`
  flex: 1;

  font-weight: 400;
  font-size: 16px;
  font-family: ${fontFredoka};
  line-height: 17.6px;
  text-align: start;

  ${props => props.theme.breakpoints.up("desktop")} {
    font-size: 20px;
    line-height: 22px;
  }
`;
